var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23332 0.741675L4.99998 3.97501L1.76665 0.741675C1.44165 0.416675 0.91665 0.416675 0.59165 0.741675C0.26665 1.06667 0.26665 1.59167 0.59165 1.91667L4.41665 5.74167C4.74165 6.06668 5.26665 6.06668 5.59165 5.74167L9.41665 1.91667C9.74165 1.59167 9.74165 1.06667 9.41665 0.741675C9.09165 0.425008 8.55832 0.416675 8.23332 0.741675Z",
    fill: "#5C715E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.0323228b7e0bd2637b7583d18c82b837.svg";
export { ForwardRef as ReactComponent };